import { Observable } from "rxjs";

import { ListaResultset } from "../../list/lista-resultset.interface";


export abstract class RelatorioController<Model, DefaultFilter> { 

  abstract carregarRelatorio(pagina?: number): void;

  // abstract getService(): DefaultService<any>;

  abstract getListaObservable(filter: DefaultFilter): Observable<ListaResultset<Model>>;

  abstract recuperarFiltros(): void;
  // TODO: futuramente quando atualizar os relatorios do RelatorioController para RelatorioAbstrato
  // o metodo recuperarFiltros(): void deve retornar RelatorioFiltros<DefaultFilter>;

  abstract getFilter(): DefaultFilter;


}